import { render, staticRenderFns } from "./MedicalInvoiceRev1.vue?vue&type=template&id=504a7a0e&"
import script from "./MedicalInvoiceRev1.vue?vue&type=script&lang=ts&"
export * from "./MedicalInvoiceRev1.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
